const apiUrl = "https://storage-showcase.ext.hpe.com/showcase_api"; //API server IP

const config = {
	apiUrl,
	// the notification websocket lives at the host root, not under /showcase_api
	wsUrl: apiUrl.replace(/^http/, "ws").replace(/\/showcase_api$/, ""),
	ssoAuthorizationUrl: "https://mylogin.hpe.com/oauth2/aus5016946Vxb1HI6697/v1/authorize",
	ssoRedirectURL: "https://storage-showcase.ext.hpe.com/login",
	ssoClientID: "0oaq1fbktcfWi0evF697",
	ssoIssuer: 'https://mylogin.hpe.com/oauth2/aus5016946Vxb1HI6697'
};

export default config;
